import BaseExecutor from 'services/sports/default/base-executor';
import {MinAdjustedPlayersValidatorBuilder} from 'services/sports/draftkings/validator/min-adjusted-players-validator-builder';
import {NonControlledHitterStackingValidatorBuilder} from 'services/sports/mlb/validator/non-controlled-hitter-stacking-validator-builder';
import {LegacyControlledHitterStackingValidatorBuilder} from 'services/sports/mlb/validator/legacy-controlled-hitter-stacking-validator-builder';
import Action from 'actions';
import BaseValidator from 'services/validations/base-validator';
import OpposingPitchersValidator from 'components/organisms/opposing-pitchers/validators/opposing-pitchers-validator';
import ProjectedOwnershipForceValidator from 'components/organisms/projected-ownership-force/validators/validator';
import LockedGamesValidator from 'services/validations/locked-games-validator';
import {ClassicValidatorBuilder} from 'services/validations/builders/classic-validator-builder';

export default class UserAdjustmentsValidatorClassicBuilder extends BaseExecutor {
    getInterface() {
        const {
            sportConfig,
            nonControlledHitterStacking: {settings: stacking},
            opposingPitchers,
            projectedOwnershipForce,
            playersData: {preparedPlayers, games},
            stacks: {hitters: legacyControlledHitterStacking},
        } = Action.getState();

        const validator = new BaseValidator();

        const classicValidatorBuilder = new ClassicValidatorBuilder().getInterface();
        validator.addSubValidators([classicValidatorBuilder]);

        if (sportConfig.isModeLateswap()) {
            const lockedGamesValidator = new LockedGamesValidator();
            lockedGamesValidator.setDependencies({games});
            validator.addSubValidators([lockedGamesValidator]);
        }

        if (projectedOwnershipForce.isEnabled()) {
            const projectedOwnershipForceValidator = new ProjectedOwnershipForceValidator();
            projectedOwnershipForceValidator.setDependencies({
                sportConfig,
                projectedOwnershipForce,
                players: preparedPlayers.groupedBy.playerId(),
            });
            validator.addSubValidators([projectedOwnershipForceValidator]);
        }

        if (opposingPitchers.isAllowed()) {
            const opposingPitchersValidator = new OpposingPitchersValidator();
            opposingPitchersValidator.setDependencies({opposingPitchers});
            validator.addSubValidators([opposingPitchersValidator]);
        }

        if (!this._isAnyStackingUsed()) {
            const minAdjustedPlayersValidator = new MinAdjustedPlayersValidatorBuilder({
                propNameOfDefaultUserPointsValue: 'adminPoints',
            }).getInterface();
            validator.addSubValidators([minAdjustedPlayersValidator]);
        }

        if (stacking.isEnabled()) {
            const nonControlledHitterStackingValidator =
                new NonControlledHitterStackingValidatorBuilder().getInterface();
            validator.addSubValidators([nonControlledHitterStackingValidator]);
        }

        if (legacyControlledHitterStacking.isEnabled()) {
            const legacyControlledHitterStackingValidator =
                new LegacyControlledHitterStackingValidatorBuilder().getInterface();
            validator.addSubValidators([legacyControlledHitterStackingValidator]);
        }

        return validator;
    }

    _isAnyStackingUsed() {
        return (
            this._isHittersStackingUsed() ||
            this._isNonControlledHitterStackingUsed() ||
            this._isPlayerCombinationStackingUsed() ||
            this._isProjectionBoostRuleUsed()
        );
    }

    _isHittersStackingUsed() {
        const {
            stacks: {hitters: hittersStacking},
        } = Action.getState();

        return hittersStacking.isEnabled();
    }

    _isNonControlledHitterStackingUsed() {
        const {
            nonControlledHitterStacking: {settings},
        } = Action.getState();

        return settings.isEnabled();
    }

    _isPlayerCombinationStackingUsed() {
        const {playerCombinationStacking} = Action.getState();

        return playerCombinationStacking.isEnabled() && playerCombinationStacking.hasItems();
    }

    _isProjectionBoostRuleUsed() {
        const {projectionBoostRule} = Action.getState();

        return projectionBoostRule.isEnabled() && projectionBoostRule.hasItems();
    }
}
